<a (click)="gotoPrev()" href="javascript:void(0)" class="link-back nomargintop">Back</a>
<div class="mt25">
    <vc-all-errors [groups]="forms" [fromContext]="true"></vc-all-errors>
</div>
<router-outlet></router-outlet>